import { useEffect } from "react";
import Vivus from "vivus";
import logo from "../../static/logo.svg";

function Loading() {
    useEffect(() => {
        new Vivus("logo", {duration: 200, file: logo, type: "oneByOne"});
    }, [])
    return (
        <div className="loading">
            <div id="logo" className="logo" />
        </div>
    );
}

export default Loading;
